import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import withThemeConfig from '../../_utils/withThemeConfig';
import Icon from "@insolus/ui-kit/components/Icon";
import { PageLinkPropType } from './_types';
export { PageLinkPropType };

var PageHeader = function PageHeader(props) {
  var icon = props.icon,
      title = props.title,
      description = props.description,
      links = props.links,
      themeConfig = props.themeConfig;
  var Button = themeConfig.baseComponents.Button;
  var nav = null;

  if (links) {
    nav = React.createElement("nav", {
      className: "PageHeader__nav"
    }, React.createElement("ul", {
      className: "PageHeader__nav-items"
    }, links.map(function (_ref) {
      var label = _ref.title,
          url = _ref.url,
          otherLinkProps = _objectWithoutProperties(_ref, ["title", "url"]);

      return React.createElement("li", {
        className: "PageHeader__nav-item",
        key: label
      }, React.createElement(Button, Object.assign({}, otherLinkProps, {
        to: url
      }), label));
    })));
  }

  return React.createElement("div", {
    className: "PageHeader"
  }, React.createElement("div", {
    className: "PageHeader__heading"
  }, React.createElement("h1", {
    className: "PageHeader__title"
  }, icon && React.createElement(Icon, {
    type: icon
  }), title), description && React.createElement("p", {
    className: "PageHeader__description"
  }, description)), nav);
};

PageHeader.defaultProps = {
  icon: undefined,
  description: undefined,
  links: []
};
export default withThemeConfig(PageHeader);